<template>
  <div>
    <div class="notice">
      <h2>准备怀宝宝了?我们为您准备了最丰富的孕妈妈食谱 ~</h2>
      <div class="tips">
        <p>
          孕前6个月戒烟酒,避免危害胚胎.孕前3个月开始补充叶酸,可预防胎儿神经管畸形,如果您在孕前达到十一体重,储备充足的钾和铁,将利于您成功怀孕,降低不良妊娠风险
        </p>
      </div>
    </div>
    <cook-item v-for="item in features_list" :key="item.r.id" :cookInfo="item">
    </cook-item>
  </div>
</template>
<script>
import url from "@/url/url.js";
import Vue from "vue";
import { NoticeBar } from "vant";
import cookItem from "./cookItem";
Vue.use(NoticeBar);
export default {
  data() {
    return {
      features_list: [],
    };
  },
  components: {
    cookItem,
  },
  created() {
    (async () => {
      let res = await this.$http.get(url.recipeUrl, {
        params: {
          keyword: "母婴",
        },
      });
      console.log(res);
      if (res.state === "success") {
        console.log(res.result);
        if (res.result) {
          let resArr = res.result.list;
          resArr.forEach((item) => {
            if (typeof item === "object" && item.r) {
              this.features_list.push(item);
            }
          });
        }
      }
      // if ((res.state = "success")) {
      //   if (res.result) {
      //     let resArr = res.result.features_list.list;
      //     resArr.forEach((item) => {
      //       if (typeof item == "object" && item.r) {
      //         this.features_list.push(item);
      //       }
      //     });
      //   }
      // } else {
      //   return false;
      // }
    })();
  },
};
</script>
<style lang="scss" scoped>
.notice {
  box-sizing: border-box;
  padding: 15px;
  background: rgba(228, 13, 131, 0.1);
  h2 {
    font-size: 16px;
    line-height: 30px;
  }
  .tips {
    font-size: 14px;
    line-height: 25px;
    color: #999;
  }
}
</style>
